import { render, staticRenderFns } from "./ResultFooter.vue?vue&type=template&id=39cea9ee&scoped=true"
import script from "./ResultFooter.vue?vue&type=script&lang=js"
export * from "./ResultFooter.vue?vue&type=script&lang=js"
import style0 from "./ResultFooter.vue?vue&type=style&index=0&id=39cea9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cea9ee",
  null
  
)

export default component.exports